import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware  from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './reducers/';

let store;

if (process.env.NODE_ENV === 'production') {    
    store = createStore(rootReducer, applyMiddleware(thunkMiddleware));
}else{    
    store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), applyMiddleware(thunkMiddleware, logger));
}

export default store;